<template>
<update-base :stakeholder_type="stakeholder_type">
    <form v-if="payment_helper_shops_status == 'success'" id="submit_form">
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <div v-for="(shop, index) in payment_helper_shops" :key="index" class="my-3">
                    <label class="switch m-0 mr-2 ml-2">
                        <input v-model="form_data[shop.id]" type="checkbox" :id="'checkbox' + shop.id" disabled>
                        <span class="slider round"></span>
                    </label>
                    {{ shop.title }}
                </div>
            </div>
        </div>
    </form>
</update-base>
</template>

<script>
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import UpdateBase from './components/update-base';
import { mapGetters } from 'vuex';
import { stakeholdersService } from '@/common/api.service';

export default {
    components: {
        UpdateBase,
    },
    data() {
        return {
            form_meta_data: {
                submit_btn_progress: false,
                submit_btn_text: i18n.t('btn.submit_changes'),
            },
            form_data: {},
        };
    },
    methods: {
        get_selected_shops() {
            stakeholdersService.get_selected_shops(this.$route.params.hashid).then((response) => {
                let selected_shops = response.data.data;

                for (let index in selected_shops) {
                    $('#checkbox' + selected_shops[index]).prop('checked', true);
                    this.form_data[selected_shops[index]] = true;
                }
            });
        }
    },
    computed: {
        ...mapGetters('gateway', [
            'payment_helper_shops',
            'payment_helper_shops_status',
        ]),
        stakeholder_type() {
            return this.$route.params.stakeholder_type;
        },
    },
    mounted() {
        this.$store.dispatch('gateway/get_payment_helper_shops').then(() => {
            this.get_selected_shops();
        });
    },
}
</script>

<style scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #d8d8d8;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #6aad27;
}

input:focus + .slider {
    box-shadow: 0 0 1px #6aad27;
}

input:checked + .slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
}
.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}
</style>
